import { MediaEnum } from './media.enum';
import { ViewLoaderEnum } from 'src/app/view/models/view-loader.enum';

export class ChapterUIModel {
  play: {
    count: number;
    autoplay: boolean;
  };

  config: {
    info: boolean;
    fullscreen: boolean;
    objectTree: boolean;
    scrubber: boolean;
    nav: boolean;
    annotations: boolean;
    playPause: boolean;
    mediaControls: MediaEnum;
    anatomyLabels: boolean;
    loader: ViewLoaderEnum;
    whiteboard: boolean;
    visibilityLayers: boolean;
    contextActions: boolean;
  };
  
}
